<template>
    <div class="rt-grid">
        <div class="rt-grid__header">
            <rt-toolbar v-if="$slots.toolbar" style="float:right;margin:2px 20px 0 0;">
                <slot name="toolbar"></slot>
            </rt-toolbar>
            <el-input :placeholder="quicksearchPlaceholder" v-if="isShowSearch" v-model="quickSearch" style="float:left;width:176px;margin-right:10px;"> 
            </el-input>
            <el-button slot="append" type="primary" @click="handleQuickSearch" style="float: left;height:30px;margin-left:10px;">{{searchButtonName}}</el-button>
            <el-button @click="handleReset" type="primary" v-if="isShowSearch&&!$slots.more" style="float: left;margin-left: 10px;height: 30px;">{{resetButtonName}}</el-button>
            <el-button @click="handleReset" type="primary" v-if="$slots.more" style="float: left;margin-left: 10px;padding: 0;width:66px;height: 30px;">
                {{resetButtonName}}
            </el-button>
            <el-button @click="handleCollapse" type="primary" v-if="$slots.more" style="float: left;margin-left: 10px;padding: 0;width:66px;height: 30px;">
                {{$t('BUTTON_MORESCREEN')}}
            </el-button>
        </div>
        <div class="rt-grid__moresearch" v-show="$slots.more && showHidden">
            <slot name="more"></slot>
           <!--  <el-row :gutter="40" type="flex">
                <el-col v-bind:span="24" style="float:right;text-align:right;">
                    <el-button type="primary" @click="handleReset" class="rt-query__reset">{{$t('BUTTON_RESET')}}</el-button>
                    <el-button type="primary" @click="handleSearch">{{$t('BUTTON_SEARCH')}}</el-button>
                </el-col>
            </el-row> -->
        </div>
        <div class="rt-grid__body">
            <slot></slot>
        </div>
        <div class="rt-grid__footer">
            <el-pagination v-if="showPagination" @size-change="handleSizeChange" @current-change="handleIndexChange" :current-page="pageIndex" :page-size="pageSize" :page-sizes="pageSizes" :layout="layout"  :total="totalRecord">
            </el-pagination>
        </div>
    </div>
</template>

<script>
export default {
  name: "RtGrid",
  data() {
    return {
      quickSearch: null,

      showHidden: false,
      isShowSearch:true,
      pageIndex: 1,
      pageSize: 20,
      layout: "sizes,total,->, prev, pager, next, jumper",
      pageSizes: [10, 20, 30, 40, 50]
    };
  },
  props: {
    quicksearchPlaceholder: String,
    showPagination: {
      type: Boolean,
      default: true,
      required: false
    },
    totalRecord: {
      type: Number,
      required: false
    },
    searchButtonName: {
      type: String,
      default: '查询',
      required: false
    },
    resetButtonName: {
      type: String,
      default: '重置',
      required: false
    },
  },
  computed: {
    iconClass() {
      return this.showHidden ? "el-icon-arrow-up" : "el-icon-arrow-down";
    }
  },
  mounted() {
    document.querySelector("body").onkeydown=(even)=>{
      if(even.keyCode=="13"){
        this.handleQuickSearch();
      }
    }
  },
  methods: {
    handleCollapse() {
      this.showHidden = !this.showHidden;
    },
    handleReset() {
      this.$emit("reset");
    },
    handleSearch() {
      this.pageIndex = 1;
      this.$emit("search");
    },

    handleQuickSearch() {
      this.pageIndex = 1;
      this.$emit("quick-search");
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.$emit("page-change", this.pageIndex, this.pageSize);
    },
    handleIndexChange(val) {
      this.pageIndex = val;
      this.$emit("page-change", this.pageIndex, this.pageSize);
    },

    getPageIndex() {
      return this.pageIndex;
    },
    setPageSizes(val){
      this.pageSizes=val;
    },
    setisShowSearch(val){
      this.isShowSearch=val;
    },
    getPageSize() {
      return this.pageSize;
    },
    getSearchString() {
      return this.quickSearch;
    },
    setSearchString(quicksearch) {
      this.quickSearch = quicksearch;
    }
  }
};
</script>
<style>
  .rt-grid__header .el-button{
    color:#fff;
  }
  .rt-grid__header .el-button:hover,
  .rt-grid__header .el-button:focus{
    color:#fff;
  }
  .rt-grid__moresearch{
    font-size:0;
  }
  .rt-grid__moresearch .el-form-item__label{
    width: initial!important;
    padding-right:10px;
  }
  .rt-grid__moresearch .el-form--inline .el-form-item__content{
    width: 130px;
  }
</style>


// WEBPACK FOOTER //
// main.vue?461f339c